import { ReduxService } from 'dashboard-services/services';

import { inspectorActions } from 'actions/modules/tools';

export const inspectorInitialState = {
  groupName: undefined,
  name: undefined,
  open: false,
  title: "File",
  type: undefined
}

export default (state = inspectorInitialState, action) => {
  switch (action.type) {
    case inspectorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}